import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: {},
    catalogue: {
      Viandes: [
        { name: "hache", prix: 1 },
        { name: "morue", prix: 1 },
        { name: "agneau", prix: 1 },
        { name: "poulet", prix: 1 }
      ],
      Sauces: [
        { name: "chien", prix: 1 },
        { name: "harissa", prix: 1 },
        { name: "autres", prix: 1 }
      ],
      Options: [
        { name: "salade", prix: 1 },
        { name: "tomate", prix: 1 },
        { name: "oignon", prix: 1 },
        { name: "oeuf", prix: 1 },
        { name: "lardon", prix: 1 }
      ],
      Boissons: [
        { name: "coca", prix: 1 },
        { name: "sprite", prix: 1 },
        { name: "eau", prix: 1 },
        { name: "oasis tropical", prix: 1 },
        { name: "autres", prix: 1 }
      ]
    },
    historique: [
      { client: "john", total: 9.9 },
      { client: "lina", total: 12.9 },
      { client: "aristote", total: 15.9 }
    ],
    selection: null,
    // {uid: menu}
    menus: {},
    client: {
      name: "",
      numero: "",
      adresse: "",
      commentaire: ""
    }
  },
  mutations: {
    changeCatalogue: function(state, path, obj) {
      state.config["set-catalog"] = [path, obj];
    },
    changeMenu: function(state, uid, obj) {
      state.config["set-menu"] = [uid, obj];
    }
  },
  actions: {},
  modules: {}
});
